import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UserData } from '../../providers/user';

@Pipe({
  name: 'userInfo2'
})

export class UserInfo2Pipe implements PipeTransform {

  constructor(
    private userProvider: UserData
  ) { }

  transform(value: string, clientId: string): Observable<any> {
    return this.userProvider.getUserById(clientId, value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/user/user.info2.ts